module.exports = __webpack_public_path__ + "img/logo_beardrug.a6f5def8.png";